import React from "react";
import CTA from "./CTA";
import logo from "../../assets/img/logo.webp";
import HeaderSocials from "./HeaderSocials";

import "./header.css";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <img loading="lazy" src={logo} alt="me" className="me__logo" />
        <h5>Hello I'm</h5>
        <h1>George Albert</h1>
        <h5 className="text-light">Front-End Developer</h5>
        <CTA />
        <HeaderSocials />
        <a href="#about" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
